// extracted by mini-css-extract-plugin
export default {"container":"hW-z","title":"iW-z","link":"jW-z"};